export default __webpack_public_path__ + "static/media/EsilioLogo.58a3b2a5.png";